import { lookupSite as lookupSiteApi } from '../../services';

export const lookupSite = async (type, thirdpartyId, query) => {
  try {
    const data = await lookupSiteApi(type, thirdpartyId, query);
    return data;
  } catch (e) {
    console.error('Unable to lookup site: ', e);
    throw new Error(e);
  }
};

export const getModelVersion = (model, activeSite) => {
  if (activeSite.version) return activeSite.version;

  const completedVersions = model.versions
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .filter((v) => v.status === 'COMPLETED');

  return completedVersions[0].id;
};
